import React, { Component, Suspense } from 'react';
import { withRouter } from 'react-router-dom';
import TravelDatesContainer from '../../../ITP/TravelDates/index';
import DeviceSelectionContainer from '../../../ITP/DeviceSelection/index';
import { connect } from 'react-redux';
import ProgressBar from '../ProgressBar';
const DestinationComp = React.lazy(() => import("../../components/ITPDestination/index"));
const PlanSelectionComp = React.lazy(() => import("../../../ITP/PlanSelection/components/index"));
const ReviewPageComp = React.lazy(() => import("../../../ITP/ReviewPage/components/index"));
class ItpTabs extends Component { // eslint-disable-line
    render() {
        let tabIndex=0;
        let stepsCompleted = 0;
        const { match, location, history,travelDate, ITP_DeviceSelectionData,Destination,PlanSelection,reviewPage } = this.props;
      
        if(location.pathname.indexOf("tpDestination") > -1) {
          stepsCompleted = Destination && Destination.pageData && Destination.pageData.data &&  Destination.pageData.data.destination && Destination.pageData.data.destination.progressBar.stepsCompleted
 
          return (
            <>
            <ProgressBar
            tabs={[
                "Destination",
                "Date",
                "Devices",
                "Plan",
                "Review"
              ]}
            stepsCompleted={stepsCompleted}
          />
          <DestinationComp />
          </>
          )
        }
        else if(location.pathname.indexOf("tpDateSelection") > -1) {
            stepsCompleted = travelDate && travelDate.data && travelDate.data.body && travelDate.data.body.data && travelDate.data.body.data.arrivalDate.progressBar.stepsCompleted;
            return (
            <>
            <ProgressBar
            tabs={[
                "Destination",
                "Date",
                "Devices",
                "Plan",
                "Review"
              ]}
            stepsCompleted={stepsCompleted}
          />
           <TravelDatesContainer />
            </>
           )
        }
        else if (location.pathname.indexOf("tpDeviceSelection") > -1) {
            stepsCompleted = ITP_DeviceSelectionData && ITP_DeviceSelectionData.data && ITP_DeviceSelectionData.data.data && ITP_DeviceSelectionData.data.data.Device && ITP_DeviceSelectionData.data.data.Device.progressBar.stepsCompleted
            return (
            <>
            <ProgressBar
            tabs={[
                "Destination",
                "Date",
                "Devices",
                "Plan",
                "Review"
              ]}
            stepsCompleted={stepsCompleted}
          />
            <DeviceSelectionContainer />
            </>
            );
        }        
        else if (location.pathname.indexOf("tpPlanSelection") > -1) {
          stepsCompleted = PlanSelection && PlanSelection.pageData && PlanSelection.pageData.data &&  PlanSelection.pageData.data.InternationalPlan && PlanSelection.pageData.data.InternationalPlan.progressBar.stepsCompleted
          return (
          <>
          <ProgressBar
          tabs={[
              "Destination",
              "Date",
              "Devices",
              "Plan",
              "Review"
            ]}
          stepsCompleted={stepsCompleted}
        />
          <PlanSelectionComp />
          </>
          );
      } 
      else if (location.pathname.indexOf("tpReview") > -1) {
        stepsCompleted = reviewPage && reviewPage.pageData && reviewPage.pageData.data &&  reviewPage.pageData.data.Review && reviewPage.pageData.data.Review.progressBar.stepsCompleted
        return (
        <>
        <ProgressBar
        tabs={[
            "Destination",
            "Date",
            "Devices",
            "Plan",
            "Review"
          ]}
        stepsCompleted={stepsCompleted}
      />
        <ReviewPageComp />
        </>
        );
    }
      
    }
}
const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = dispatch => ({
    
});
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ItpTabs));